import { createBaseQuery } from '../helper/createBaseQuery'
import { tokenSlice } from '../slice/tokenSlice'

const businessApi = tokenSlice.injectEndpoints({
  reducerPath: 'business',
  baseQuery: createBaseQuery(),
  tagTypes: ['Business'],
  endpoints(builder) {
    return {
      getBusiness: builder.query({
        query: () => {
          return {
            url: 'BusinessUnit/GetBusinessUnitList',
            method: 'GET',
          }
        },
      }),
      // getBusinessByUser: builder.query({
      //   query: () => {
      //     return {
      //       url: 'BusinessUnit/GetBusinessUnitListByUser',
      //       method: 'GET',
      //     }
      //   },
      // }),
      getBusinessByUser: builder.query({
        query: () => {
          return {
            url: 'BusinessUnit/GetBusinessUnitListByCurrentUser',
            method: 'GET',
          }
        },
      }),

    }
  },
})

export const { useGetBusinessQuery, useGetBusinessByUserQuery } = businessApi
export { businessApi }
